module.exports = __webpack_public_path__ + "img/img78.17129a87.png";